import React, { useEffect } from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";

const TRUSTARC_SCRIPT_ID = 'trustarc-consent-notice-script';
const TRUSTARC_NOTICE_SRC = 'https://consent.trustarc.com/v2/notice/jwg1ns';
const TRUSTARC_LOCALE_MAP = {
  cn: 'zh_HANS',
  en: 'en',
};
function getTrustArcNoticeSrc(language) {
  const privacyPolicyLink = `${window.location.origin}/${language}/privacy`;

  return `${TRUSTARC_NOTICE_SRC}?locale=${TRUSTARC_LOCALE_MAP[language]}&privacypolicylink=${encodeURIComponent(privacyPolicyLink)}`;
}

function loadTrustArcNotice(language) {
  const scriptSrc = getTrustArcNoticeSrc(language);
  const existingScript = document.getElementById(TRUSTARC_SCRIPT_ID);

  if (existingScript?.src === scriptSrc) {
    return;
  }

  existingScript?.remove();

  const script = document.createElement('script');
  script.id = TRUSTARC_SCRIPT_ID;
  script.type = 'text/javascript';
  script.async = true;
  script.src = scriptSrc;
  const trustArcContainer = document.getElementById('teconsent');
  if (trustArcContainer) {
    trustArcContainer.innerHTML = '';
  }
  (trustArcContainer || document.body).appendChild(script);
}

function PrivacyDialog() {
  const { i18n } = useTranslation();

  useEffect(() => {
    loadTrustArcNotice(i18n.language);
  }, [i18n.language]);

  return (
    <>
      <div id="consent-banner"></div>
      <div id="teconsent" className="trustarc_consent" title="Cookie Preferences"></div>
    </>
  );
}

export default PrivacyDialog;
